import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { fetchHistoryItemDetail, fetchPreSignedUrl, selectBulkUploadrHistoryItemDetail, selectPreSignedUrl } from "./BulkUploadrSlice"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { DataGrid, GridCallbackDetails, GridRowParams, GridSortModel, MuiEvent, gridFilteredSortedRowIdsSelector, selectedGridRowsSelector } from "@mui/x-data-grid"
import { Button, Typography } from "@mui/material"
import { Box } from "@mui/system"
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import BulkUploadHistoryGridToolBar from "../utils/BulkUploadHistoryGridToolBar"
import RefreshIcon from '@mui/icons-material/Refresh'
import './BulkUploadHistory.css'
import { Download } from "@mui/icons-material"

function BulkUploadHistory() {
  const { slug } = useParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: 'id',
      sort: 'asc',
    },
  ])
  const preSignedUrl = useAppSelector(selectPreSignedUrl)
  const historyItemDetail = useAppSelector(selectBulkUploadrHistoryItemDetail)
  const historyItemColumns = [
    { width: 100, field: 'id', type: 'number', valueGetter: (params: any) => params.row.position + 1 },
    { flex: 1, field: 'address', headerName: 'Address', valueGetter: (params: any) => `${params.row.formattedAddress}` },
    { width: 100, field: 'comp', headerName: 'Comp', type: 'number', valueGetter: (params: any) => params.row.errorCode ? '~' : `$ ${params.row.comp}` },
    { width: 100, field: 'confidence', headerName: 'Confidence', valueGetter: (params: any) => params.row.errorCode ? '~' : `${params.row.confidence}%` },
  ]
  useEffect(() => {
    if (slug) {
      dispatch(fetchHistoryItemDetail({ slug }))
      dispatch(fetchPreSignedUrl({ slug }))
    }
  }, [slug])
  return (<>
    <Box sx={{ display: 'flex', alignContent: 'start', marginBottom: 2 }}>
      <Button variant='text' size='small' onClick={() => navigate('/bulk')}> <NavigateBeforeIcon /> Back</Button>
      {slug && <Button variant='text' size='small' onClick={() => dispatch(fetchHistoryItemDetail({ slug }))}> <RefreshIcon /> Refresh</Button>}
      {slug && <Button variant='text' size='small' href={preSignedUrl}> <Download /> Download</Button>}
    </Box>
    {historyItemDetail?.length ? <><DataGrid disableRowSelectionOnClick slots={{ toolbar: BulkUploadHistoryGridToolBar }}
      sx={{
        // disable cell selection style
        '.MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        // pointer cursor on ALL rows
        '& .MuiDataGrid-row:hover': {
          cursor: 'pointer'
        }
      }}
      getRowClassName={(params) => params.row.errorCode ? `dg-row-error` : ``}
      rows={historyItemDetail} columns={historyItemColumns}
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
      onRowClick={(params: GridRowParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        if (params.row.slug === undefined || params.row.slug === '' || params.row.slug === 'na') return
        navigate(`/analysis/slug/${params.row.slug}`)
      }} />
      <Box sx={{ display: 'flex', alignContent: 'start', marginTop: 2 }}>
        <Button variant='text' size='small' onClick={() => navigate('/bulk')}> <NavigateBeforeIcon /> Back</Button>
      </Box>
    </> : <>
      <Typography variant="h5">Bulk processing has not started yet, please check back later.</Typography>
    </>}
  </>)
}

export default BulkUploadHistory